var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-con"},[_c('Card',{attrs:{"icon":"log-in","title":"欢迎登录","bordered":false}},[_c('div',{staticClass:"form-con"},[_c('login-form',{on:{"on-success-valid":_vm.handleSubmit}}),_c('p',{staticClass:"login-tip"},[_vm._v("输入用户名和密码登录")])],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }